import { ITableData } from '../../components/AppTable/model';
import { commonActions } from '../actionTypes';
import produce from 'immer';
import { usersPermissionsActions } from '../actionTypes/usersPermissions';

const defaultTableState = Object.freeze<ITableData>({
    sorting: {
        dataKey: 'notificationsNumber',
        direction: 'desc'
    },
    selectedIds: [],
    animateIds: new Map(),
    filters: {}
});

export interface IUsersPermissionsState {
    searchTerm: string;
    tableState: ITableData;
}

export const usersPermissionsInitialState: IUsersPermissionsState = {
    searchTerm: '',
    tableState: {
        ...defaultTableState
    }
};

export default function usersPermissionsReducer(
    state: IUsersPermissionsState = usersPermissionsInitialState,
    action: $TSFixMe
): IUsersPermissionsState {
    switch (action.type) {
        case commonActions.SYSTEM_CHANGED: {
            return {
                ...state,
                ...usersPermissionsInitialState
            };
        }

        case usersPermissionsActions.SET_SEARCH_TERM: {
            return { ...state, searchTerm: action.payload };
        }

        case usersPermissionsActions.UPDATE_USERS_PERMISSIONS_TABLE_STATE: {
            const { changes } = action.payload;

            return produce(state, updatedState => {
                const key = Object.keys(changes)[0];
                updatedState.tableState[key] = changes[key];
            });
        }

        case usersPermissionsActions.RESET: {
            return {
                ...state,
                searchTerm: usersPermissionsInitialState.searchTerm,
                tableState: { ...usersPermissionsInitialState.tableState }
            };
        }

        default:
            return state;
    }
}
